import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { FiCode, FiDatabase, FiServer, FiMonitor } from 'react-icons/fi';
import './AboutSection.css';

const AboutSection = ({ profile }) => {
  const [ref, isVisible] = useScrollAnimation();

  const highlights = [
    { icon: FiCode, label: 'Frontend', value: 'React, Angular, Blazor' },
    { icon: FiServer, label: 'Backend', value: '.NET, ASP.NET Core, C#' },
    { icon: FiDatabase, label: 'Database', value: 'SQL Server, EF Core' },
    { icon: FiMonitor, label: 'Broadcast', value: 'Automation, VizRT' },
  ];

  return (
    <section className="section about-section" ref={ref}>
      <div className="container">
        <div className={`about-grid ${isVisible ? 'fade-in' : ''}`}>
          <div className="about-content">
            <h2 className="section-title" style={{ textAlign: 'left' }}>About Me</h2>
            <p className="about-bio">{profile?.bio}</p>
            <div className="about-info">
              <div className="info-item">
                <span className="info-label">Name:</span>
                <span className="info-value">{profile?.fullName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Email:</span>
                <span className="info-value">{profile?.email}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Location:</span>
                <span className="info-value">{profile?.location || 'India'}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Experience:</span>
                <span className="info-value">{profile?.totalExperience || 3}+ Years</span>
              </div>
            </div>
          </div>
          <div className="about-highlights">
            {highlights.map((item, i) => (
              <div key={i} className="highlight-card glass">
                <item.icon size={32} className="highlight-icon" />
                <h4>{item.label}</h4>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
